// extracted by mini-css-extract-plugin
export default {"wrapper":"ExchangeRate_wrapper__VCARi","copier":"ExchangeRate_copier__s1aeC"};